// extracted by css-extract-rspack-plugin
export default {"container":"src-modules-desktop-modules-files-integration-components-NewFolderPlaceholder-NewFolderPlaceholder-module__container-IPC2ia","iconWrapper":"src-modules-desktop-modules-files-integration-components-NewFolderPlaceholder-NewFolderPlaceholder-module__iconWrapper-D5BOF7","wrapper":"src-modules-desktop-modules-files-integration-components-NewFolderPlaceholder-NewFolderPlaceholder-module__wrapper-nehjzD","nameSlot":"src-modules-desktop-modules-files-integration-components-NewFolderPlaceholder-NewFolderPlaceholder-module__nameSlot-ylA_Er"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-modules-desktop-modules-files-integration-components-NewFolderPlaceholder-NewFolderPlaceholder-module__container-IPC2ia\",\"iconWrapper\":\"src-modules-desktop-modules-files-integration-components-NewFolderPlaceholder-NewFolderPlaceholder-module__iconWrapper-D5BOF7\",\"wrapper\":\"src-modules-desktop-modules-files-integration-components-NewFolderPlaceholder-NewFolderPlaceholder-module__wrapper-nehjzD\",\"nameSlot\":\"src-modules-desktop-modules-files-integration-components-NewFolderPlaceholder-NewFolderPlaceholder-module__nameSlot-ylA_Er\"}";
        // 1793873552500
        var cssReload = require("../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  